<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <InputGroup
              label="IAM Root Account Email"
              type="email"
              v-model="customer.email"
              placeholder="Enter your email"
              :required="true"
              :disabled="true"
          />
        </div>
        <div class="col-md-6">
          <InputGroup
              label="Root Account Service Number"
              type="text"
              v-model="customer.service_number"
              placeholder="Enter your root service number"
              :required="true"
              :disabled="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <InputGroup
              label="First Name"
              type="text"
              v-model="form.first_name"
              placeholder="Enter your first name"
              :required="true"
              :validation-error="errorFor('first_name')"
          />
        </div>
        <div class="col-md-6">
          <InputGroup
              label="Last Name"
              type="text"
              v-model="form.last_name"
              placeholder="Enter your last name"
              :required="true"
              :validation-error="errorFor('last_name')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <InputGroup
              label="Password"
              type="password"
              v-model="form.password"
              placeholder="Enter mixed character (aA1@$!%*?#) of 8 digits."
              :required="true"
              :validation-error="errorFor('password')"
          />
        </div>
        <div class="col-md-6">
          <InputGroup
              label="Confirm Password"
              type="password"
              v-model="form.password_confirmation"
              placeholder="Enter same as password"
              :required="true"
              :validation-error="errorFor('password_confirmation')"
          />
        </div>
      </div>

      <p>Multi Factor Authentication</p>
      <div class="row">
        <div class="col-md-6">
          <InputGroup
              label="Email"
              type="email"
              v-model="form.email"
              placeholder="Enter your email"
              :required="true"
              :validation-error="errorFor('email')"
          />
        </div>
        <div class="col-md-6">
          <InputGroup
              label="Mobile Phone"
              type="text"
              v-model="form.phone"
              placeholder="Enter your phone number"
              :required="true"
              :validation-error="errorFor('phone')"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="policy" class="col-form-label">Policy</label>
            <Multiselect
                v-model="form.policy"
                :options="policies"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select a policy"
                label="name"
                track-by="id"
                :optionHeight="20"
            />
            <v-errors :errors="errorFor('policy_ids')"></v-errors>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="policy_group" class="col-form-label">Policy Group</label>
            <Multiselect
                v-model="form.policyGroup"
                :options="policyGroups"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select a policy group"
                label="name"
                track-by="id"
                :optionHeight="20"
            />
            <v-errors :errors="errorFor('policy_group_ids')"></v-errors>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <label for="policy_group" class="col-form-label">Permissions</label>
            <Multiselect
                v-model="form.permissions"
                :options="permissions"
                :multiple="true"
                :showLabels="false"
                :close-on-select="true"
                placeholder="Select a permissions"
                label="name"
                track-by="id"
                :optionHeight="20"
            />
            <v-errors :errors="errorFor('policy_group_ids')"></v-errors>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="d_flex_start">
          <button type="button" class="btn btn-primary btn-md  width_100p" :disabled="lyLoading" @click="submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputGroup from "@/components/FormControl/InputGroupComponent.vue";
import Multiselect from 'vue-multiselect';

export default {
  name: 'UserForm',
  components: {InputGroup, Multiselect},
  props: ['closeModal', 'loadData', 'editId'],
  data() {
    return {
      lyLoading: false,
      form: {
        email: '',
        phone: '',
      },
      policies: [],
      policyGroups: [],
      permissions: [],
    }
  },
  computed: {
    ...mapGetters({
        customer: 'auth/getUser'
    })
  },
  created() {
    if (this.editId) {
      this.getCustomer()
    }
    this.policyList()
    this.policyGroupList()
  },
  mounted() {
    this.getAccessPermissionsList()
  },
  methods: {
    getCustomer(){
      this.axios.get(`/customers/${this.editId}`)
      .then(({data}) => {
        this.form = data.data
        this.form.permissions = data.data.customerPermissions
      })
    },
    policyList() {
      this.axios.get('/policy-list')
      .then(({data}) => {
        this.policies = data.data
      })
    },
    policyGroupList() {
      this.axios.get('/policy-group-list')
      .then(({data}) => {
        this.policyGroups = data.data
      })
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let apiUrl;
      if (this.editId) {
        apiUrl = `customers/${this.editId}`;
        this.form._method = 'PUT'
      } else {
        apiUrl = `customers`;
      }

      if ( this.form.policy) {
        this.form.policy_ids = this.form.policy?.map((item) => item.id)
      }
      if ( this.form.policyGroup) {
        this.form.policy_group_ids = this.form.policyGroup?.map((item) => item.id)
      }
      if ( this.form.permissions) {
        this.form.permission_ids = this.form.permissions?.map((item) => item.id)
      }

      this.axios.post(apiUrl, this.form)
          .then(({ data }) => {
            if (data.success) {
              this.loadData()
              this.showSuccessMsg(data.message);
              this.closeModal()
            } else {
              this.showFailMsg(data.message);
            }
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.lyLoading = false;
          })
    },
    getAccessPermissionsList() {
      this.axios.get('/access-permissions-list').then(({ data }) => {
        this.permissions = data
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>

</style>
  